var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_c('info-icon',{attrs:{"id":"tooltip-info"}}),_c('b-tooltip',{attrs:{"target":"tooltip-info","triggers":"hover"}},[_vm._v(" 游戏信息 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }